import PropTypes from 'prop-types';

const disabledspan = (
  <span style={{ color: 'red', fontSize: '1.5vh', fontWeight: 'bold' }}> Disabled </span>
);
const italicStyle = { fontStyle: 'italic' };

let lastValComma = '';
const StoreNameLabel = ({ storeName, lastIndex, active }) => {
  lastValComma = lastIndex && ',';

  return active ? (
    <>
      {storeName}
      {lastValComma}
    </>
  ) : (
    <span style={italicStyle}>
      {storeName} - {disabledspan}
      {lastValComma}
    </span>
  );
};

StoreNameLabel.propTypes = {
  storeName: PropTypes.string,
  lastIndex: PropTypes.bool,
  active: PropTypes.bool
};

export default StoreNameLabel;
